import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import deletionStatusService from '../services/deletionStatusService';

export const useNavigationGuard = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    // Перехоплюємо всі кліки на посилання
    const handleLinkClick = async (event) => {
      // Перевіряємо чи це внутрішнє посилання
      const target = event.target.closest('a');
      if (!target) return;

      const href = target.getAttribute('href');
      if (!href || href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('tel:')) {
        return; // Зовнішні посилання пропускаємо
      }

      // Дозволені маршрути
      const allowedPaths = [
        '/uk/gdpr-dashboard',
        '/en/gdpr-dashboard',
        '/gdpr-dashboard'
      ];

      const isAllowedPath = allowedPaths.some(path => 
        href === path || href.endsWith(path)
      );

      if (isAllowedPath) return; // Дозволені маршрути пропускаємо

      // Використовуємо централізований сервіс
      try {
        const deletionStatus = await deletionStatusService.getStatus();
        
        // Якщо є запит на видалення, блокуємо навігацію
        if (deletionStatus && deletionStatus.deletionRequested) {
          // Блокуємо навігацію та перенаправляємо
          event.preventDefault();
          event.stopPropagation();
          
          console.log('🚫 Navigation blocked: User has deletion request');
          window.location.replace('/uk/gdpr-dashboard');
        }
      } catch (error) {
        console.error('Error checking deletion status on navigation:', error);
      }
    };

    // Додаємо слухач на весь документ
    document.addEventListener('click', handleLinkClick, true);

    return () => {
      document.removeEventListener('click', handleLinkClick, true);
    };
  }, [user]);
};

export default useNavigationGuard;